import { render, staticRenderFns } from "./Dxarticles.vue?vue&type=template&id=2148f298&scoped=true&lang=true&"
import script from "./Dxarticles.vue?vue&type=script&lang=js&"
export * from "./Dxarticles.vue?vue&type=script&lang=js&"
import style0 from "./Dxarticles.vue?vue&type=style&index=0&id=2148f298&prod&scoped=scoped&lang=css&"
import style1 from "./Dxarticles.vue?vue&type=style&index=1&id=2148f298&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2148f298",
  null
  
)

export default component.exports